import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const RegionalCooperation = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-teal-50 via-white to-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              地域連携
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              医療機関の皆様との連携を通じて、心不全患者様の早期発見と適切な治療をサポートします
            </p>
          </div>
        </div>
      </section>

      {/* 連携の目的 */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">連携の目的</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-white p-8 rounded-xl border border-teal-100">
              <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-pulse-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">早期発見の推進</h3>
              <p className="text-gray-600 leading-relaxed">
                地域のかかりつけ医との連携により、心不全の早期発見と迅速な対応を実現します。
              </p>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-white p-8 rounded-xl border border-emerald-100">
              <div className="w-16 h-16 bg-emerald-500 rounded-full flex items-center justify-center mb-6">
                <i className="ri-hospital-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">シームレスな医療提供</h3>
              <p className="text-gray-600 leading-relaxed">
                急性期から回復期、慢性期まで切れ目のない医療を提供し、患者様の生活の質を向上させます。
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-white p-8 rounded-xl border border-cyan-100">
              <div className="w-16 h-16 bg-cyan-500 rounded-full flex items-center justify-center mb-6">
                <i className="ri-team-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">情報共有の円滑化</h3>
              <p className="text-gray-600 leading-relaxed">
                医療機関間での情報共有を円滑にし、より適切な治療方針の決定をサポートします。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 連携の流れ */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">連携の流れ</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-8">
              {/* Step 1 */}
              <div className="flex gap-6 items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  1
                </div>
                <div className="flex-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">初診・スクリーニング</h3>
                  <p className="text-gray-600 leading-relaxed">
                    かかりつけ医での定期検診や症状の確認により、心不全の疑いがある患者様を早期に発見します。
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex gap-6 items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  2
                </div>
                <div className="flex-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">紹介・精密検査</h3>
                  <p className="text-gray-600 leading-relaxed">
                    当院へご紹介いただき、心エコー検査、心臓カテーテル検査などの精密検査を実施します。
                  </p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex gap-6 items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  3
                </div>
                <div className="flex-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">治療・入院管理</h3>
                  <p className="text-gray-600 leading-relaxed">
                    必要に応じて入院治療や手術を実施し、急性期の管理を行います。
                  </p>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex gap-6 items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  4
                </div>
                <div className="flex-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">退院後フォロー・逆紹介</h3>
                  <p className="text-gray-600 leading-relaxed">
                    退院後は、かかりつけ医と連携しながら継続的な慢性管理とリハビリテーションをサポートします。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 連携のメリット */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">連携のメリット</h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-teal-50 to-white p-8 rounded-xl border border-teal-100">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-heart-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">患者様にとって</h3>
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-500 mt-1 flex-shrink-0"></i>
                      <span>早期発見による重症化の予防</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-500 mt-1 flex-shrink-0"></i>
                      <span>専門的な治療へのスムーズなアクセス</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-teal-500 mt-1 flex-shrink-0"></i>
                      <span>継続的なサポート体制</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-white p-8 rounded-xl border border-emerald-100">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-emerald-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-stethoscope-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">医療機関にとって</h3>
                  <ul className="space-y-2 text-gray-600">
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-emerald-500 mt-1 flex-shrink-0"></i>
                      <span>専門的な診断・治療のバックアップ</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-emerald-500 mt-1 flex-shrink-0"></i>
                      <span>迅速な情報共有と連携</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <i className="ri-check-line text-emerald-500 mt-1 flex-shrink-0"></i>
                      <span>地域医療の質の向上</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 退院後の心臓リハビリテーション連携 */}
      <section className="py-16 bg-gradient-to-br from-teal-50 via-white to-emerald-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <div className="bg-white p-12 rounded-2xl shadow-lg border border-teal-100">
            <div className="w-20 h-20 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-heart-add-line text-4xl text-white"></i>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">退院後の心臓リハビリテーションや運動処方箋発行ができる医療機関と連携しています</h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              当院での外来リハビリテーションに通院が困難な方に対して、外来リハビリテーションを行っていただける医療機関や、心肺運動負荷試験を用いた運動指導を行っていただける医療機関と連携しております。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://heart-rehab.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-teal-500 text-white text-base font-medium rounded-lg hover:bg-teal-600 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer inline-block"
              >
                <i className="ri-external-link-line mr-2"></i>
                東京都心リハネットワーク
              </a>
              <a
                href="/referral-hospitals"
                className="px-8 py-4 bg-white text-teal-500 text-base font-medium rounded-lg border-2 border-teal-500 hover:bg-teal-50 transition-all duration-300 whitespace-nowrap cursor-pointer inline-block"
              >
                <i className="ri-hospital-line mr-2"></i>
                当病院から紹介実績のある病院一覧
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default RegionalCooperation;
